const allInput = new Map()

function handleFocus(ev) {
  ev.target.select()
}

export default {
  install(app) {
    app.directive('select', {
      mounted(el) {
        allInput.set(el, null)
        if (['INPUT', 'TEXTAREA'].includes(el.tagName.toUpperCase())) {
          allInput.set(el, el)
          el.addEventListener('focus', handleFocus)
        } else {
          let input = el.getElementsByTagName('input')
          let textarea = el.getElementsByTagName('textarea')
          if (input && input[0]) {
            input = input[0]
            allInput.set(el, input)
            input.addEventListener('focus', handleFocus)
          } else if (textarea && textarea[0]) {
            textarea = textarea[0]
            allInput.set(el, textarea)
            textarea.addEventListener('focus', handleFocus)
          }
        }
      },
      beforeUnmount(el) {
        if (allInput.get(el)) {
          allInput.get(el).removeEventListener('focus', handleFocus)
        }
        allInput.delete(el)
      }
    })
  }
}
